import { render, staticRenderFns } from "./seterp.vue?vue&type=template&id=11a3cd8b&scoped=true"
import script from "./seterp.vue?vue&type=script&lang=ts"
export * from "./seterp.vue?vue&type=script&lang=ts"
import style0 from "./seterp.vue?vue&type=style&index=0&id=11a3cd8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a3cd8b",
  null
  
)

export default component.exports